module.exports = __webpack_public_path__ + "static/media/do-not-show.7aae217e.svg";